<template>
  <div>
    <van-row :gutter="5">
      <van-col :span="12">
        <van-button block size="small" type="info" @click="goto('from-receive')">从应收账款中获取</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block size="small" type="info">从申报收入外收款中获取</van-button>
      </van-col>
    </van-row>
    <van-row class="mt10" :gutter="5">
      <van-col :span="12">
        <van-button block size="small" type="info" @click="apply()">从应收利息、股息中获取</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block size="small" type="info">新客户登记</van-button>
      </van-col>
    </van-row>
    <van-form class="mt10">
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="收款金额"
        placeholder="请输入金额"
        :rules="[{ required: true, message: '请输入金额' }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        :value="formData.RPer"
        label="付款单位"
        placeholder="请选择"
        @click="showCollectionCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.Date"
        label="收款日期"
        placeholder="请选择"
        @click="showPaymentDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.PayCategory"
        label="资金类别"
        placeholder="请选择"
        @click="showFundCategory = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.DetailRPType"
        label="收款账户"
        placeholder="请选择"
        @click="showPaymentAccount = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.Currency"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.InvType"
        label="收款类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        :value="formData.InvTypeDts"
        label="收款子类别"
        placeholder="请选择"
        @click="showPaymentSubType = true"
      />
    </van-form>
    <van-row class="mt10" :gutter="5">
      <van-col :span="12">
        <van-button block type="primary" plain>上传附件</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block type="primary" @click="submit()">提交</van-button>
      </van-col>
    </van-row>
    <!--付款单位弹窗-->
    <van-popup v-model="showCollectionCompany" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.collectionCompany"
        @confirm="onCollectionCompanyConfirm"
        @cancel="showCollectionCompany = false"
      />
    </van-popup>
    <!--收款日期-->
    <van-popup v-model="showPaymentDate" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onShowPaymentDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--资金类别-->
    <van-popup v-model="showFundCategory" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.fundCategory"
        @confirm="onFundCategoryConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--收款账户-->
    <van-popup v-model="showPaymentAccount" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentAccount"
        @confirm="onPaymentAccountConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currency"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--收款类别-->
    <van-popup v-model="showPaymentType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentType"
        @confirm="onPaymentTypeConfirm"
        @cancel="showPaymentType = false"
      />
    </van-popup>
    <!--收款子类别-->
    <van-popup v-model="showPaymentSubType" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.paymentSubType"
        @confirm="onPaymentSubTypeConfirm"
        @cancel="showPaymentSubType = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import {
    getPartnersAllFun,
    getBankInfoFun,
    getPayOrReceivablesTypeFun,
    getStreamAccountShipFun,
    createReceivablesRecordFun,
    getReceivablesListFun
  } from '@/api/payment'
  import {getCurrencyApi} from "@/api/regist";
  import {Toast} from 'vant'

  export default {
    name: "Recordreceipts",
    data() {
      return {
        RP_GUID: this.$route.params.id,//路由上传递过来的RP_GUID，如果有值是编辑，没有值是新增
        formData: {
          Log_c: 'a',
          RP_GUID: '',
          Operation: '',
          Remark: '',
          Mark: '',
          Record: '',
          IE_GUID: '',
          InvNo: '',
          BA_GUID: '',//详细类别
          Creator: '',
          SumAmount: '',//收款金额
          Date: '',//收款日期
          PayCategoryID: '',//资金类别ID
          PayCategory: '',//资金类别名称
          Currency: '',//货币
          RPer: '',//付款单位
          InvType: '',//收款类别
          InvTypeDts: '',//收款子类别
          DetailRPTypeID: '',//收款账户ID
          DetailRPType: '',//收款账户名称
          C_GUID: this.getCookie('CompanyInfo').companyId,//companyId
        },
        showCollectionCompany: false,//收款单位弹窗
        showPaymentDate: false,//付款日期
        showFundCategory: false,//付款账户
        showPaymentAccount: false,//资金类别
        showCurrency: false,//货币
        showPaymentType: false,//付款类别
        showPaymentSubType: false,//付款子类别
        showDetailType: false,//详细类别
        popupData: {
          collectionCompany: [],//收款单位
          fundCategory: [],//资金类别
          paymentAccount: [],//付款账户
          currency: [],//货币
          paymentType: [//付款类别
            {
              text: '经营活动付款',
              value: '经营活动付款'
            },
            {
              text: '投资活动付款',
              value: '投资活动付款'
            },
            {
              text: '筹资活动付款',
              value: '筹资活动付款'
            }
          ],
          paymentSubType: [],//付款子类别
        },
      }
    },
    mounted() {
      this.getCustomer();
      this.getCurrency();
      this.getBankInfo();
      this.getPayOrReceivablesType();
      if (this.RP_GUID) {
        this.getReceivablesList()
      }
    },
    methods: {
      //获取到付款的全部数据
      async getReceivablesList() {
        let params = {
          pageSize: 100,
          pageIndex: 1,
          C_GUID: this.getCookie('CompanyInfo').companyId,
          record: '',
          dateBegin: '',
          dateEND: '',
          customer: '',
          incomeGrp: '',
          InvTypeDts: '',
          RP_GUID: '',
          customerName: this.searchString
        };
        let response = await getReceivablesListFun(params);
        if (response.success) {
          this.formData = response.result.find(item => {
            return item.RP_GUID === this.RP_GUID
          });
          console.log(this.formData);
        }
      },
      //付款单位确定按钮
      onCollectionCompanyConfirm(value) {
        this.showCollectionCompany = false;
        this.formData.RPer = value.text;
      },
      //收款日期确定按钮
      onShowPaymentDateConfirm(value) {
        this.showPaymentDate = false;
        this.formData.Date = this.moment(value).format('YYYY-MM-DD');
      },
      //资金类别确定按钮
      onFundCategoryConfirm(item) {
        this.showFundCategory = false;
        this.formData.PayCategoryID = item.value;
        this.formData.PayCategory = item.text;
      },
      //收款账户确定按钮
      onPaymentAccountConfirm(item) {
        this.showPaymentAccount = false;
        this.formData.DetailRPTypeID = item.value;
        this.formData.DetailRPType = item.text;
      },
      //货币确定按钮
      onCurrencyConfirm(item) {
        this.showCurrency = false;
        this.formData.Currency = item.value;
      },
      //收款类别确定按钮
      onPaymentTypeConfirm(value) {
        this.showPaymentType = false;
        this.formData.InvType = value.text;
        this.getSubInvType(value.text);
      },
      //收款子类别确定按钮
      onPaymentSubTypeConfirm(item) {
        this.showPaymentSubType = false;
        this.formData.InvTypeDts = item.value;
      },
      //付款单位
      async getCustomer() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPartnersAllFun(params);
        if (response.success) {
          response.result.map(item => {
            this.popupData.collectionCompany.push({
              text: item.Name,
              value: item.BP_GUID
            })
          });
        }
      },
      //银行账户
      async getBankInfo() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getBankInfoFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.paymentAccount.push({
              text: item.label,
              value: item.value
            })
          })
        }
      },
      //资金类别
      async getPayOrReceivablesType() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPayOrReceivablesTypeFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.fundCategory.push({
              text: item.label,
              value: item.value,
            })
          })
        }
      },
      //货币类型
      async getCurrency() {
        const response = await getCurrencyApi();
        if (response.success) {
          response.result.map(item => {
            this.popupData.currency.push({
              text: item.Code,
              value: item.Code
            })
          });
        }
      },
      //收款子类别
      async getSubInvType(value) {
        const params = {
          streamFlag: 'P'
        };
        const response = await getStreamAccountShipFun(params);
        if (response.success) {
          response.result.map(item => {
            if (item.GroupName === value)
              this.popupData.paymentSubType.push({
                text: item.LASName,
                value: item.LASName
              })
          })
        }
      },
      async submit() {
        const response = await createReceivablesRecordFun(this.formData);
        if (response.success) {
          Toast.success('提交成功');
          this.$router.push({path: "/home"})
        }
      },
      goto() {
        this.$router.push({path: '/collection/from-receive'})
      }
    }
  }
</script>

